import { useLayoutEffect as t } from "react";
import { theSame as o } from "../utils/compare.js";
import i from "../utils/clone.js";

function n(n, r, f) {
  t(function () {
    if (n && void 0 !== f) {
      var t = r.setter,
          e = r.getter,
          u = r.validate,
          c = void 0 === u ? function () {
        return !0;
      } : u,
          a = r.equals,
          p = void 0 === a ? o : a,
          v = r.clone,
          m = void 0 !== v && v;

      if (t && c(f)) {
        if (e) {
          var l = function (t, o) {
            return "function" == typeof o ? o(t) : t[o]();
          }(n, e);

          if (!!p(f, l)) return;
        }

        var s = m ? i(f) : f;
        !function (t, o, i) {
          if (o) "function" == typeof o ? o(t, i) : "function" == typeof t[o] && t[o](i);
        }(n, t, s);
      }
    }
  }, [n, f]);
}

export { n as useBindProp };